import React from 'react'
import {
  Table
} from 'reactstrap'
import styled from 'styled-components'
import { confirmAlert } from 'react-confirm-alert'

import { FaTrash } from 'react-icons/fa'

import 'react-confirm-alert/src/react-confirm-alert.css'

const TrashButton = styled(FaTrash)`
  cursor: pointer;
`

const ItemTablePublications = ({ item, remove }) => {
  const confirm = () => {
    confirmAlert({
      title: 'Confirmar exclusão',
      message: 'Tem certeza que quer excluir essa publicação?',
      buttons: [
        {
          label: 'Sim',
          onClick: () => remove(item.id)
        },
        {
          label: 'Não',
          onClick: () => {}
        }
      ]
    })
  }

  return (
    <tr>
      <td className='align-middle' width='200'>
        <img
          width='200'
          src={item.image}
          alt='publication'
        />
      </td>
      <td className='align-middle'>{item.title}</td>
      <td className='align-middle'>{item.description}</td>
      <td className='align-middle'>{item.link}</td>
      <td className='align-middle'>
        <TrashButton onClick={confirm} />
      </td>
    </tr>
  )
}

const TablePublications = ({ remove, publications }) => {
  const { list, loading } = publications

  if (loading) return null

  return (
    <Table>
      <thead>
        <tr>
          <th />
          <th>Título</th>
          <th>Descrição</th>
          <th>Link</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {list.map((item, index) =>
          <ItemTablePublications item={item} remove={remove} />
        )}
      </tbody>
    </Table>
  )
}

export default TablePublications



// WEBPACK FOOTER //
// ./src/components/molecules/TablePublications/TablePublications.js